(function() {
	// Module
	var CheckboxGroupValidator = (function() {
		var __private = {
			form: null,
			errorsContainerClass: "errMessages",
			wrapperClassName: "field",
			groupParentSelector: ".field > .checkboxGroup",
			requiredTextFieldClass: "requiredTextField",
			titleSelector: ".field > h4",
			type: "checkbox",

			set(form, options) {
				if(form instanceof HTMLFormElement) this.form = form;
				else throw new Error("Form not found");

				if(options) {
					if(options.type)                this.type                = options.type;
					if(options.wrapperClassName)    this.wrapperClassName    = options.wrapperClassName;
					if(options.groupParentSelector) this.groupParentSelector = options.groupParentSelector;
				}
			},

			listener() {
				if(__private.form instanceof HTMLFormElement) {
					__private.form.addEventListener("click", function(event) {
						event = event || window.event;
						var target = event.target;

						new Promise((resolve, reject) => {
							if(target instanceof HTMLElement) resolve();
						})
							.then(() => {
								if(__private.form.lastElementChild.classList.contains(__private.errorsContainerClass))
						   			__private.form.lastElementChild.innerHTML = "";
							})
							.then(() => {
								__private.validate();
							});
					});
				}
			},

			validate() {
				var groups;
				var textFields;

				if(__private.form instanceof HTMLFormElement) {
					groups = __private.form.querySelectorAll(__private.groupParentSelector);
					textFields = __private.form.getElementsByClassName(__private.requiredTextFieldClass);

					// checkboxes
					for (let i = 0; i < groups.length; i++) {
						const div = groups[i];
						const wrapp = searchElementByClassName(div, __private.wrapperClassName);
						let inputs = div.querySelectorAll(`input[type='${__private.type}']`);

						setTimeout(() => {
							if((!wrapp || wrapp.style.display !== "none") && div.style.display !== "none")
								__private.checkRequireds(inputs);
						}, 0);
					}

					// text inputs
					for (let i = 0; i < textFields.length; i++) {
						const inp = textFields[i];

						setTimeout(() => {
							if(inp instanceof HTMLInputElement && inp.required && !inp.value && inp.parentElement.style.display !== "none")
								__private.textRequireds(inp);
						}, 0);
					}
				}
			},

			checkRequireds(inputs) {
				var isChecked = false;
				var message   = "";
				var step      = 0;

				// search checked element
				for (let i = 0; i < inputs.length; i++) {
					const element = inputs[i];
					
					if(element.checked) {
						isChecked = true;
						break;
					}
				}

				// set / remove required
				for (let i = 0; i < inputs.length; i++) {
					const element = inputs[i];
					
					if(isChecked) element.required = false;
					else element.required = true;
				}

				// create / remove error message
				if(inputs.length > 0 ) {
					let groupTitle = inputs[0].parentElement.previousElementSibling;

					// step number
					step = __private.step(inputs[0]);

					// group name
					if(groupTitle) {
						if(step !== 0) message = `<b>${groupTitle.textContent}</b> is required (step <b>${step}</b>)!`;
						else message = `<b>${groupTitle.textContent}</b> is required!`;
					}

					// add MESSAGE
					if(!isChecked) __private.err(message);
				}
			},

			textRequireds(input) {
				var step    = __private.step(input);
				var message = `Field <b>"${input.name}"</b> is required (step <b>${step}</b>)!`;

				__private.err(message);
			},

			createErrContainer() {
				if(__private.form instanceof HTMLElement) {
					if(!__private.form.lastElementChild.classList.contains(__private.errorsContainerClass)) {
						let div = document.createElement("div");

						div.classList.add(__private.errorsContainerClass);
						div.style.color = "red";

						__private.form.appendChild(div);
					}
				}
			},

			step(el) {
				var step = 0;
				var stepBody   = searchElementByClassName(el, "step-form__step");
				var stepTitle  = null;
				if(stepBody instanceof HTMLElement) stepTitle = stepBody.previousElementSibling;

					// step number
				if(stepTitle instanceof HTMLElement && stepTitle.classList.contains("step-form__step-title"))
					step = stepTitle.textContent;
				
				return step;
			},

			err(message) {
				new Promise((resolve, reject) => {
					var errors;

					if(__private.form.lastElementChild.classList.contains(__private.errorsContainerClass)) {
						errors = __private.form.lastElementChild;
						resolve(errors);
					}
				})
					.then(errors => {
						var msg = message;

						for (let i = 0; i < errors.children.length; i++) {
							const p = errors.children[i];

							if(p instanceof HTMLElement && p.innerHTML === msg) msg = "";
						}

						return msg;
					})
					.then(msg => {
						if(msg !== "") {
							let err = document.createElement("p");
							err.innerHTML = message;
		
							__private.form.lastElementChild.appendChild(err);
						}
					});
			}
			
		};

		return {
			init(form, options) {
				__private.set(form, options);
				__private.createErrContainer();
				__private.validate();
				__private.listener();
			}
		};
	})();



	// Run script
	document.addEventListener("DOMContentLoaded", function() {

		var form = document.querySelector("#steps-uid-0.editForm");
		
		if(form instanceof HTMLFormElement) {
			CheckboxGroupValidator.init(form);

			// MILEAGE
			mileageControl();
		}

		function mileageControl() {
			var mileage   = document.querySelector("input[name='miles']");
			var isMileage = document.getElementById("isActualMileage");
			var requiredClass = "requiredTextField";

			if(isMileage && isMileage.checked) {
				mileage.required = true;
				mileage.classList.add(requiredClass);
			} else {
				mileage.required = false;
				mileage.classList.remove(requiredClass);
			}
		}

	});
})();